import axios from "./axios";
import language from "./language";
export default async (phone_area_code: string, phone: string) => {
    const { data } = await axios.post("user/resend", {
        lang: language(),
        phone_area_code,
        phone,
        // recaptcha_token: await window.grecaptcha.execute('6LdoWDIpAAAAAEaCpBaxQj_fm81y7SjBAZeAd_7f', { action: 'submit' })
    });
    return data;
}